import { createSelector } from '@reduxjs/toolkit'

// eslint-disable-next-line import/no-cycle
import { store } from 'providers/store'
import { get } from 'utils/lodash'

export const useGetUserInfo = createSelector(() => {
  const state = store.getState()
  return get(state, 'AuthReducer.userInfo', {})
})

export const getUserInfo = () => {
  const state = store.getState()
  return get(state, 'AuthReducer.userInfo', {})
}
